import { Download, X } from 'lucide-react'
import { useInstallPrompt } from '@/hooks/useInstallPrompt'

export function InstallPrompt() {
    const { canInstall, install, dismiss } = useInstallPrompt()

    if (!canInstall) return null

    return (
        <div className="fixed bottom-20 left-1/2 -translate-x-1/2 z-[60] flex items-center gap-3 px-4 py-3 rounded-full border border-border-light/30 dark:border-border-dark/30 bg-surface-light/95 dark:bg-surface-dark/95 shadow-lg backdrop-blur-md animate-in slide-in-from-bottom-5 fade-in duration-300">
            <Download className="w-5 h-5 text-primary" />
            <p className="text-text-primary-light dark:text-text-primary-dark text-sm font-medium">
                Install Mackinac
            </p>
            <button
                onClick={install}
                className="ml-1 px-3 py-1 text-sm font-medium rounded-full bg-primary text-white hover:bg-primary-dark transition-colors flex-shrink-0"
            >
                Install
            </button>
            <button
                onClick={dismiss}
                aria-label="Dismiss install prompt"
                className="p-1 text-text-secondary-light dark:text-text-secondary-dark hover:text-text-primary-light dark:hover:text-text-primary-dark transition-colors flex-shrink-0"
            >
                <X className="w-4 h-4" />
            </button>
        </div>
    )
}
